var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 22.5H16C18.2061 22.5 20 20.7061 20 18.5V6.5C20 4.2944 18.2061 2.5 16 2.5H8C5.7939 2.5 4 4.2944 4 6.5V18.5C4 20.7061 5.7939 22.5 8 22.5ZM6 6.5C6 5.397 6.8975 4.5 8 4.5H16C17.1025 4.5 18 5.397 18 6.5V18.5C18 19.6025 17.1025 20.5 16 20.5H8C6.8975 20.5 6 19.6025 6 18.5V6.5Z",
    fill: "#2D3036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.4999H11C11.5527 16.4999 12 16.0526 12 15.4999C12 14.9472 11.5527 14.4999 11 14.4999H9C8.4473 14.4999 8 14.9472 8 15.4999C8 16.0526 8.4473 16.4999 9 16.4999ZM9 19.4999H15C15.5527 19.4999 16 19.0526 16 18.4999C16 17.9472 15.5527 17.4999 15 17.4999H9C8.4473 17.4999 8 17.9472 8 18.4999C8 19.0526 8.4473 19.4999 9 19.4999ZM10.5283 12.3817C10.6758 12.4608 10.8379 12.4999 11 12.4999C11.1943 12.4999 11.3877 12.4433 11.5547 12.3319L14.5547 10.3319C14.833 10.1464 15 9.83444 15 9.49994C15 9.16544 14.833 8.85344 14.5547 8.66794L11.5547 6.66794C11.2481 6.46234 10.8526 6.44434 10.5283 6.61814C10.2031 6.79244 10 7.13124 10 7.49994V11.4999C10 11.8686 10.2031 12.2074 10.5283 12.3817Z",
    fill: "#2D3036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.80132c7b9600fcee02d073423de395d7.svg";
export { ForwardRef as ReactComponent };